var path = '@collectivehealth/get-care/components/blueDistinctionCenterBadge/blueDistinctionCenterBadge.html';
var html = "<button class=\"BlueDistinctionCenterBadge__statusTag\">\n  <span class=\"BlueDistinctionCenterBadge__statusText\">\n    {{ BlueDistinctionCenterBadge.name }}\n  </span>\n</button>\n";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;